import React, { memo, useCallback } from 'react'

import { Cube, Icon, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { styleImageUrl } from 'Pods/ThreeDStudio/Components/ViewerSidebar/Components/StylePanel/mockData'
import { iconSizeMedium } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { closeStylePanel, openStylePanel } from 'Pods/ThreeDStudio/Store/actions/ui'

const emptyStyleIcon = <Icon svgComponent={Cube} size={iconSizeMedium} color="dark" notSpaced />

function StyleField() {
  const t = useTranslation()
  const style = useThreeDStudioStore(state => state.renderSettings.style)
  const isStylePanelOpen = useThreeDStudioStore(state => state.ui?.isStylePanelOpen)

  const handleClick = useCallback(() => {
    if (isStylePanelOpen) {
      closeStylePanel()

      return
    }

    openStylePanel()
  }, [isStylePanelOpen])

  return (
    <div className="render-tab__field">
      <span className="render-tab__label cgt-body-base-semibold">
        {t('viewerSidebar.enhance.render.styleLabel')}
      </span>
      <button
        type="button"
        aria-expanded={isStylePanelOpen}
        className={classnames(
          'render-tab__style-field',
          isStylePanelOpen && 'render-tab__style-field--active',
        )}
        onClick={handleClick}
      >
        {style
          ? (
            <img className="render-tab__style-thumb" src={styleImageUrl(style.id)} alt="" decoding="async" />
          )
          : (
            <span className="render-tab__style-thumb render-tab__style-thumb--empty" aria-hidden="true">
              {emptyStyleIcon}
            </span>
          )}
        <span className="render-tab__style-name cgt-caption-semibold">
          {style ? style.name : t('viewerSidebar.enhance.render.styleNone')}
        </span>
      </button>
    </div>
  )
}

export default memo(StyleField)
